import { container } from "tsyringe";

// pages
import { ClassDataFormatConverter } from "@/pages/student-setting/ui/popup/setting-class/models/converters/ClassDataFormatConverter";
import { StringDateOrDateConverter } from "@/pages/student-setting/ui/popup/setting-class/services/service/StringDateOrDateConverter";
import type { ClassDataFormatConverterStructure } from "@/pages/student-setting/ui/popup/setting-class/models/converters/ClassDataFormatConverter";

import type { StudentLatestStudyRecordConverterStructure } from "@/pages/student-setting/models/converter/StudentLatestStudyRecordConverter";
import { StudentLatestStudyRecordConverter } from "@/pages/student-setting/models/converter/StudentLatestStudyRecordConverter";

import { UserItemConverter } from "@/pages/ai-tutor/models/converters/UserItemConverter";
import type { UserItemConverterStructure } from "@/pages/ai-tutor/models/converters/UserItemConverter";

import { SessionMessagesConverter } from "@/pages/ai-tutor/models/converters/SessionMessagesConverter";
import type { SessionMessagesConverterStructure } from "@/pages/ai-tutor/models/converters/SessionMessagesConverter";

import { SessionNameConverter } from "@/pages/ai-tutor/models/converters/SessionNameConverter";
import type { SessionNameConverterStructure } from "@/pages/ai-tutor/models/converters/SessionNameConverter";

export const register = () => {
    container.register<ClassDataFormatConverterStructure>("ClassDataFormatConverter", {
        useValue: new ClassDataFormatConverter(new StringDateOrDateConverter()),
    });

    /** student-setting */
    container.register<StudentLatestStudyRecordConverterStructure>(
        "StudentLatestStudyRecordConverter",
        {
            useValue: container.resolve(StudentLatestStudyRecordConverter),
        },
    );

    /** ai-tutor */
    container.register<UserItemConverterStructure>("UserItemConverter", {
        useValue: container.resolve(UserItemConverter),
    });
    container.register<SessionMessagesConverterStructure>("SessionMessagesConverter", {
        useValue: container.resolve(SessionMessagesConverter),
    });
    container.register<SessionNameConverterStructure>("SessionNameConverter", {
        useValue: container.resolve(SessionNameConverter),
    });
};
